import Summary from "../../Components/SignUp/Summary";
import React, {useEffect, useState} from "react";
import {SubscriptionPlans} from "../../Types/Enums/SignUp";
import {SignUpStepType} from "../../Types/SignUp/SignUpStep";
import {SignUpPlanType} from "../../Types/SignUp/SignUpPlan";
import AccountCreation from "../../Components/SignUp/AccountCreation";
import SignUpGenericSection from "../../Components/SignUp/SignUpGenericSection";
import {
    BusinessAddressesOverview, LetterPerks,
    LettersOverview, ParcelPerks, ParcelsOverview,
    PlanPerks,
    PlansOverview,
    StreetAddressesOverview
} from "../../Data/SignUp";
import SignupDevNav from "../../Components/SignUp/SignupDevNav";
import { useLayout } from "@twigsby/frontend-framework";
import { ScrollToActive } from "@twigsby/helpers";
import { ScrollRestoration } from "react-router-dom";

const initialActiveStep = { complete: false, visible: true, value: null };
const initialStep = { complete: false, visible: false, value: null};
const initialSummary = { complete: false, visible: false, value: null, showAnnualCost: true };

const SignUp = () => {
    const { setContentOnlyLayout } = useLayout();

    const [ plan, setPlan ] = useState<SignUpStepType>(initialActiveStep);
    const [ streetAddress, setStreetAddress ] = useState<SignUpStepType>(initialStep);
    const [ businessAddress, setBusinessAddress ] = useState<SignUpStepType>(initialStep);
    const [ letterOption, setLetterOption ] = useState<SignUpStepType>(initialStep);
    const [ parcelOption, setParcelOption ] = useState<SignUpStepType>(initialStep);
    const [ summary, setSummary ] = useState<SignUpStepType>(initialSummary);

    const [ accountCreation, setAccountCreation ] = useState<SignUpStepType>(initialStep);

    useEffect (() => {
        if(plan.complete) {
            ScrollToActive(document.querySelector('.sign-up-section:not(.sign-up-section-hide)') as Element, 'sign-up-section');
        }
    }, [plan, streetAddress, businessAddress, letterOption, parcelOption, summary, accountCreation]);

    useEffect(() => {
        setContentOnlyLayout(true)
    }, []);

    const SetPlanPath = (id: number) => {
        switch(id) {
            case SubscriptionPlans.StreetAddresses:
                setStreetAddress({ complete: streetAddress.complete,  visible: true, value: streetAddress.value });
                setBusinessAddress(initialStep);
                setLetterOption(initialStep);
                setParcelOption(initialStep);
                setSummary(initialSummary);
                break;
            case SubscriptionPlans.BusinessAddresses:
                setStreetAddress(initialStep);
                setBusinessAddress({ complete: businessAddress.complete,  visible: true, value: businessAddress.value });
                setLetterOption(initialStep);
                setParcelOption(initialStep);
                setSummary(initialSummary);
                break;
            case SubscriptionPlans.ParcelAddress:
                setStreetAddress(initialStep);
                setBusinessAddress(initialStep);
                setLetterOption(initialStep);
                setParcelOption({ complete: parcelOption.complete,  visible: true, value: parcelOption.value });
                setSummary(initialSummary);
                break;
            case SubscriptionPlans.PoBoxAddresses:
            case SubscriptionPlans.RedirectionAddresses:
                setStreetAddress(initialStep);
                setBusinessAddress(initialStep);
                setLetterOption({ complete: letterOption.complete,  visible: true, value: letterOption.value });
                setParcelOption(initialStep);
                setSummary(initialSummary);
                break;
        }
    }


    const UpdatePlan = (editing: boolean, e?: SignUpPlanType) => {
        setPlan({ complete: true, visible: editing, value: e ? e : editing ? plan.value : null });
        if(e) {
            SetPlanPath(e.id);
        }
    }

    const UpdateStreetAddress = (editing: boolean, e?: SignUpPlanType) => {
        setStreetAddress({ complete: editing ? streetAddress.complete : true,  visible: editing, value: editing ? streetAddress.value : e ? e : editing ? streetAddress.value : null });
        if(!editing) {
            setLetterOption({complete: letterOption.complete, visible: true, value: letterOption.value});
        }
    }

    const UpdateBusinessAddress = (editing: boolean, e?: SignUpPlanType) => {
        setBusinessAddress({ complete: editing ? businessAddress.complete : true,  visible: editing, value: editing ? businessAddress.value : e ? e : editing ? businessAddress.value : null });
        if(!editing) {
            setLetterOption({ complete: letterOption.complete,  visible: true, value: letterOption.value });
        }
    }

    const UpdateLetterOption = (editing: boolean, e?: SignUpPlanType) => {
        setLetterOption({ complete: editing ? letterOption.complete : true,  visible: editing, value: editing ? letterOption.value : e ? e : editing ? letterOption.value : null });
        if(!editing && e) {
            setSummary({ complete: summary.complete, visible: true, value: summary.value });
        }
    }

    const UpdateParcelOption = (editing: boolean, e?: SignUpPlanType) => {
        setParcelOption({ complete: editing ? parcelOption.complete : true,  visible: editing, value: editing ? parcelOption.value : e ? e : editing ? parcelOption.value : null });
        if(!editing && e) {
            setSummary({ complete: summary.complete, visible: true, value: summary.value });
        }
    }

    const UpdateSummary = (editing: boolean, e?: any) => {
        setSummary({ complete:  editing ? summary.complete : true,  visible: editing, value: editing ? summary.value : e ? e : editing ? summary.value : null });
        if(!editing && e) {
            setAccountCreation({ complete: accountCreation.complete, visible: true, value: accountCreation.value });
        }
    }

    const UpdateAccountCreation = (e: any) => {
        setAccountCreation({ complete: accountCreation.complete,  visible: true, value: accountCreation.value });
    }

    return (
        <div className={'content-main'}>
            <div className={'container-narrow p-md'}>
                <div className={'flex-row align-center justify-center'}>
                    <div className={'header-logo-container logo-big'}>
                        <span className='logo-emblem' />
                    </div>
                </div>
            </div>

            <div className={'container-narrow pb-xl'}>

                <SignupDevNav />

                <h3 className={'mb-xs text-center'}>Sign up to UK Postbox</h3>

                <div className='row'>
                    <div className={'col-xs-12'}>

                        {/*                <SignUpNavigation
                            plan={plan}
                            streetAddress={streetAddress}
                            businessAddress={businessAddress}
                            letterOption={letterOption}
                            parcelOption={parcelOption}
                            summary={summary}
                        />*/}

                        <SignUpGenericSection
                            label={'Select Plan'}
                            completeLabel={`${plan.value?.label} Plan` ?? 'Complete'}
                            plansOverview={PlansOverview}
                            planPerks={PlanPerks}
                            onCancelCallback={() => setPlan({ complete: plan.complete, visible: false, value: plan.value })}
                            onEditCallback={() => UpdatePlan(true)}
                            onChangeCallback={(e: SignUpPlanType) => UpdatePlan(false, e)}
                            complete={plan.complete}
                            visible={plan.visible}
                            value={plan.value?.id}
                        />

                        <SignUpGenericSection
                            label={'Select Street'}
                            completeLabel={`${streetAddress.value?.labelExtra}` ?? 'Complete'}
                            plansOverview={StreetAddressesOverview}
                            planPerks={PlanPerks}
                            onCancelCallback={() => setStreetAddress({ complete: streetAddress.complete, visible: false, value: streetAddress.value })}
                            onEditCallback={() => UpdateStreetAddress(true)}
                            onChangeCallback={(e: SignUpPlanType) => UpdateStreetAddress(false, e)}
                            complete={streetAddress.complete}
                            visible={streetAddress.visible}
                            value={streetAddress.value?.id}
                        />

                        <SignUpGenericSection
                            label={'Select Business'}
                            completeLabel={`${businessAddress.value?.labelExtra}` ?? 'Complete'}
                            plansOverview={BusinessAddressesOverview}
                            planPerks={PlanPerks}
                            onCancelCallback={() => setBusinessAddress({ complete: businessAddress.complete, visible: false, value: businessAddress.value })}
                            onEditCallback={() => UpdateBusinessAddress(true)}
                            onChangeCallback={(e: SignUpPlanType) => UpdateBusinessAddress(false, e)}
                            complete={businessAddress.complete}
                            visible={businessAddress.visible}
                            value={businessAddress.value?.id}
                        />

                        <SignUpGenericSection
                            label={'Select Letter'}
                            completeLabel={`${letterOption.value?.label}` ?? 'Complete'}
                            plansOverview={LettersOverview}
                            planPerks={LetterPerks}
                            hideMarks={true}
                            hideExcluded={true}
                            onCancelCallback={() => setLetterOption({ complete: letterOption.complete, visible: false, value: letterOption.value })}
                            onEditCallback={() => UpdateLetterOption(true)}
                            onChangeCallback={(e: SignUpPlanType) => UpdateLetterOption(false, e)}
                            complete={letterOption.complete}
                            visible={letterOption.visible}
                            value={letterOption.value?.id}
                        />

                        <SignUpGenericSection
                            label={'Select Parcel'}
                            completeLabel={`${parcelOption.value?.label}` ?? 'Complete'}
                            plansOverview={ParcelsOverview}
                            planPerks={ParcelPerks}
                            hideMarks={true}
                            hideExcluded={true}
                            onCancelCallback={() => setParcelOption({ complete: parcelOption.complete, visible: false, value: parcelOption.value })}
                            onEditCallback={() => UpdateParcelOption(true)}
                            onChangeCallback={(e: SignUpPlanType) => UpdateParcelOption(false, e)}
                            complete={parcelOption.complete}
                            visible={parcelOption.visible}
                            value={parcelOption.value?.id}
                        />

                        <Summary
                            onCancelCallback={() => setSummary({ complete: summary.complete, visible: false, value: summary.value })}
                            onEditCallback={() => UpdateSummary(true)}
                            onChangeCallback={(e: any) => UpdateSummary(false, e)}
                            complete={summary.complete}
                            label={'Select Billing'}
                            completeLabel={`${summary.value?.label} Billing` ?? 'Complete'}
                            visible={summary.visible}
                            value={summary.value?.id}

                            selectedPlan={streetAddress.value ?? businessAddress.value}
                            selectedLetterPlan={letterOption.value}
                            selectedParcelPlan={parcelOption.value}
                        />

                        <AccountCreation
                            label={'User Details'}
                            completeLabel={'Complete'}
                            complete={accountCreation.complete}
                            visible={accountCreation.visible}
                            onCancelCallback={() => null}
                            onChangeCallback={(e: any /*SignUpAccountCreationType*/) => UpdateAccountCreation(e)}
                        />

                    </div>

                </div>
            </div>
        </div>
    )
}

export default SignUp
